import { NativeEvent } from '../NativeEvent';

export interface AppsflyerSetUidPayload {
  /** ID do usuário interno; string vazia = anonimiza (chamado no logout). */
  userId: string;
}

/**
 * Define o customer user ID no AppsFlyer para amarrar todos os eventos
 * subsequentes ao usuário no painel e relatórios/API.
 *
 * Disparar em login e a cada mudança de userId. No logout, dispatch
 * com userId='' (string vazia) para limpar a associação.
 */
export class AppsflyerSetUidEvent extends NativeEvent<
  'appsflyerSetUid',
  AppsflyerSetUidPayload
> {
  readonly type = 'appsflyerSetUid';
  readonly payload: AppsflyerSetUidPayload;

  constructor(userId: string | number) {
    super();
    this.payload = { userId: String(userId ?? '') };
  }
}
